import { embedFor, embedUnavailableReason, platformOf } from "./jobMedia";

/**
 * Plays the job's *source* clip from its platform. The downloaded file lives on
 * the machine and is never uploaded here, so this is always the original post.
 */
const JobVideoEmbed = ({ job }) => {
  const embed = embedFor(job);
  const platform = platformOf(job);
  const link = job?.raw?.download?.extra?.webpage_url || job?.link;

  if (!embed) {
    const reason = embedUnavailableReason(job);
    if (!reason) return null;
    return (
      <div className="text-muted font-size-12 mb-3">
        {reason}
        {link && (
          <>
            {" "}
            <a href={link} target="_blank" rel="noreferrer">
              Open the source
            </a>
          </>
        )}
      </div>
    );
  }

  // Vertical formats (Reels, TikToks, Shorts) get a phone-shaped frame; a normal
  // YouTube video gets the usual 16:9.
  const frameStyle = embed.vertical
    ? { width: "100%", maxWidth: "325px", height: "580px" }
    : { width: "100%", aspectRatio: "16 / 9" };

  return (
    <div className="mb-3">
      <iframe
        title={`${embed.platform} preview`}
        src={embed.src}
        style={{ ...frameStyle, border: 0, borderRadius: "6px" }}
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen
        loading="lazy"
      />
      <div className="text-muted font-size-11 mt-1">
        {embed.note ? `${embed.note} ` : ""}
        {link && (
          <a href={link} target="_blank" rel="noreferrer">
            open on {platform ?? "source"}
          </a>
        )}
      </div>
    </div>
  );
};

export default JobVideoEmbed;
